import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AdvertisementSection from "../components/AdvertisementSection";
import Listings from "../components/Listings";




function Home() {
    return (
        <div className="d-flex flex-column min-vh-100 " style={{ backgroundColor: "#fff", paddingLeft: "15px", paddingRight: "15px" }}>
            <Navbar />


            <AdvertisementSection />

            <Listings />
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <Footer />

        </div>
    );
}

export default Home;
